var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "panel-basic",
        {
          attrs: {
            title: "Change my Password",
            id: "passwordSettings",
            collapsable: true,
            headingLevel: 4
          }
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("MAIN_CONTENT.General.changeMyPasswordForced")) +
                "\n\t\t"
            )
          ]),
          _vm._v(" "),
          !!_vm.passwordFields.responseMessage
            ? _c(
                "div",
                {
                  staticClass: "alert",
                  class: {
                    "alert-success":
                      _vm.passwordFields.responseType === "success",
                    "alert-danger": _vm.passwordFields.responseType === "danger"
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.passwordFields.responseMessage) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-6 col-md-4" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.General.oldPasswordStartCaseWithColon"
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordFields.oldPassword,
                        expression: "passwordFields.oldPassword"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "password", maxlength: "30" },
                    domProps: { value: _vm.passwordFields.oldPassword },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.passwordFields,
                          "oldPassword",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-6 col-md-4" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("strong", [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.General.newPasswordStartCaseWithColon"
                          )
                        ) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 userWizard" },
                  [
                    _c("password", {
                      ref: "password",
                      staticClass: "password-input",
                      attrs: {
                        name: "password",
                        toggle: true,
                        secureLength: _vm.passwordMinLegth,
                        showStrengthMeter: true,
                        autocomplete: "new-password",
                        maxlength: "40",
                        disabled: _vm.passwordFields.oldPassword.length <= 0
                      },
                      model: {
                        value: _vm.passwordFields.newPassword,
                        callback: function($$v) {
                          _vm.$set(_vm.passwordFields, "newPassword", $$v)
                        },
                        expression: "passwordFields.newPassword"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6 col-md-4" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("strong", [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.General.confirmNewPasswordStartCaseWithColon"
                          )
                        ) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 userWizard" },
                  [
                    _c("password", {
                      ref: "password",
                      staticClass: "password-input",
                      attrs: {
                        name: "password",
                        toggle: true,
                        secureLength: _vm.passwordMinLegth,
                        showStrengthMeter: true,
                        autocomplete: "new-password",
                        maxlength: "40",
                        disabled: _vm.passwordFields.oldPassword.length <= 0
                      },
                      model: {
                        value: _vm.passwordFields.confirmNewPassword,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.passwordFields,
                            "confirmNewPassword",
                            $$v
                          )
                        },
                        expression: "passwordFields.confirmNewPassword"
                      }
                    }),
                    _vm._v(" "),
                    _vm.passwordFields.newPassword.length > 0 &&
                    _vm.passwordMessage > 0
                      ? _c("small", { staticClass: "help-block text-danger" }, [
                          _vm.passwordMessage === 1
                            ? _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\tPassword must must have the following characteristics: \n\t\t\t\t\t\t\t\t"
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "At least " +
                                        _vm._s(_vm.passwordMinLegth) +
                                        " characters - the more characters, the better."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v("A mixture of letters and numbers.")
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.passwordMessage === 2
                            ? _c("span", [
                                _vm._v("Confirm password does not match")
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-4 col-xs-offset-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { disabled: _vm.passwordMessage !== 0 },
                  on: { click: _vm.saveNewPassword }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("commonText.save")) +
                      "\n\t\t\t\t"
                  )
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }